module.exports = __webpack_public_path__ + "img/published.7d39830b.svg";